export default {
  title: 'Modificare Disponibilitate',
  amend_availabilities_form: {
    date: {
      label: 'Selectați o Dată',
    },
    times: {
      label: 'Ture și ore de deschidere',
      description:
        'Definiți orele de deschidere pentru data selectată. Faceți turele mai lungi, mai scurte sau blocați-le. Cel puțin o tură trebuie să fie deschisă.',
      breakfast: {
        label: 'Mic dejun',
      },
      lunch: {
        label: 'Prânz',
      },
      dinner: {
        label: 'Cină',
      },
    },
  },
  reason: {
    label: 'Adăugați un motiv (opțional)',
    placeholder: 'Introduceți descrierea...',
  },
  buttons: {
    save: 'Salvați',
  },
  projects: {
    online_shop: 'Magazin Online',
    reservations: 'Rezervări',
    storefront: 'Vitrină',
  },
  error_messages: {
    creation_failed: 'Crearea excepției a eșuat',
  },
};
